<h2 mat-dialog-title>Confirm Deletion</h2>
<mat-dialog-content>
  <p>Are you sure you want to delete <strong>{{ data.sale_item_name }}</strong>?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="warn" (click)="onConfirm()">Delete</button>
</mat-dialog-actions>